import React, { useState, useEffect } from 'react';

import {
  ApInput,
  ApButtonDanger,
  ApButtonSecondary,
  ApButtonGroup,
} from '@alixpartners/ui-components';
import capitalize from 'lodash/capitalize';

import { Modal } from './DeleteAllDataModal.styles';

interface IProps {
  isLoading?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  actionPhrase?: string;
}

export const DeleteAllDataModal: React.FC<IProps> = ({
  onSubmit,
  onCancel,
  isLoading,
  actionPhrase = 'delete all files',
}) => {
  const [isSubmitDisabled, setSubmitDisabled] = useState(true);
  const [value, setValue] = useState('');

  useEffect(() => {
    setSubmitDisabled(!value || value.toLowerCase() !== actionPhrase);
  }, [value]);

  return (
    <Modal
      isOpen
      header={
        isLoading
          ? `${capitalize(actionPhrase.split(' ')[0])} in-progress...`
          : `Are you sure you want to ${actionPhrase}?`
      }
      isDismissible
      footer={() => (
        <ApButtonGroup justifyContent="flex-end">
          <ApButtonSecondary small onClick={onCancel}>
            Cancel
          </ApButtonSecondary>
          <ApButtonDanger
            small
            onClick={onSubmit}
            disabled={isLoading || isSubmitDisabled}
          >
            {capitalize(actionPhrase)}
          </ApButtonDanger>
        </ApButtonGroup>
      )}
      hasClosed={onCancel}
    >
      {isLoading ? (
        'Please wait.'
      ) : (
        <React.Fragment>
          <p>You are about to {actionPhrase} from the application.</p>
          <br />
          <ApInput
            value={value}
            name="deleteCheck"
            label={`Type [${actionPhrase.toUpperCase()}] in the box below and click submit button.`}
            onChange={setValue}
          />
        </React.Fragment>
      )}
    </Modal>
  );
};
